import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=9b318264&"
import script from "./UserList.vue?vue&type=script&lang=js&"
export * from "./UserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b318264')) {
      api.createRecord('9b318264', component.options)
    } else {
      api.reload('9b318264', component.options)
    }
    module.hot.accept("./UserList.vue?vue&type=template&id=9b318264&", function () {
      api.rerender('9b318264', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examples/list/UserList.vue"
export default component.exports